import React from 'react'
import { useIntl } from 'react-intl'
import { FormSubGroup, Label } from '../../layout'
import { FilterSelect } from '../components/FilterSelect'
import { SelectContainer, TowingJobStatus, useTowingJobFilterContext } from '../context'
import { towingJobFilterMessages } from '../messages'
import { formatMessageSafe } from '../../../util/translateInputOptions'

interface StatusOption {
  label: string
  value: TowingJobStatus
}
interface StatusFilterProps {
  options?: StatusOption[]
}

export const StatusFilter = ({ options }: StatusFilterProps) => {
  const { values, setValues } = useTowingJobFilterContext()
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  const statusOptions: StatusOption[] = [
    { label: formatMessage(towingJobFilterMessages.statusAll), value: 'ALL' },
    { label: formatMessage(towingJobFilterMessages.statusCompleted), value: 'COMPLETED' },
    { label: formatMessage(towingJobFilterMessages.statusOpen), value: 'OPEN' },
  ]
  const optionsValues = options ? options : statusOptions

  const handleStatusChange = (e: any) => {
    const selectedValue = e.value

    setValues({
      ...values,
      status: selectedValue,
    })
  }

  return (
    <FormSubGroup>
      <Label htmlFor="filter-select">{formatMessage(towingJobFilterMessages.statusLabel)}</Label>
      <SelectContainer>
        <FilterSelect
          isSearchable={false}
          options={optionsValues}
          value={optionsValues
            .filter(option => values.status === option.value)
            .map(option => ({ value: option.value, label: option.label }))}
          onChange={handleStatusChange}
        />
      </SelectContainer>
    </FormSubGroup>
  )
}
